import { ConnectButton } from '@rainbow-me/rainbowkit'
import { Wallet } from '@phosphor-icons/react'
import { useDisconnect } from 'wagmi'
import { useEffect, useCallback } from 'react'

// Global variable to store the openConnectModal function
declare global {
  interface Window {
    openRainbowKitConnectModal?: () => void;
  }
}

export function CustomConnectButton() {
  const { disconnect } = useDisconnect()

  // Handle account changes
  useEffect(() => {
    if (window.ethereum) {
      const handleAccountsChanged = (accounts: string[]) => {
        if (accounts.length === 0) {
          // User disconnected their wallet
          disconnect()
        }
      }

      window.ethereum.on?.('accountsChanged', handleAccountsChanged)

      return () => {
        window.ethereum?.removeListener?.('accountsChanged', handleAccountsChanged)
      }
    }
  }, [disconnect])

  // Cleanup global function on unmount
  useEffect(() => {
    return () => {
      delete window.openRainbowKitConnectModal;
    };
  }, []);

  return (
    <ConnectButton.Custom>
      {({
        account,
        chain,
        openAccountModal,
        openChainModal,
        openConnectModal,
        mounted,
      }) => {
        const ready = mounted
        if (!ready) return null

        // Update global function directly
        window.openRainbowKitConnectModal = openConnectModal;

        return (
          <div className="flex items-center gap-2">
            {(() => {
              if (!account || !chain) {
                return (
                  <button
                    onClick={openConnectModal}
                    className="p-2 rounded-lg hover:bg-sky-500/20 text-secondary bg-green-500/10"
                    title="Connect Wallet"
                  >
                    <Wallet size={20} />
                  </button>
                )
              }

              if (chain.unsupported) {
                return (
                  <button
                    onClick={openChainModal}
                    className="text-red-500 text-sm"
                  >
                    Wrong network
                  </button>
                )
              }

              return (
                <button
                  onClick={openAccountModal}
                  className="p-2 rounded-lg hover:bg-sky-500/20 text-secondary bg-green-500/10"
                  title={account.displayName}
                >
                  <Wallet size={20} />
                </button>
              )
            })()}
          </div>
        )
      }}
    </ConnectButton.Custom>
  )
} 